var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Betting/Voting/GoalCard.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var GoalCard = function (_React$Component) {
  (0, _inherits2.default)(GoalCard, _React$Component);

  var _super = _createSuper(GoalCard);

  function GoalCard() {
    (0, _classCallCheck2.default)(this, GoalCard);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(GoalCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          goal = _this$props.goal;
      return _react.default.createElement(_Basic.Column, {
        isFlex: true,
        center: true,
        zIndex: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15,
          columnNumber: 13
        }
      }, _react.default.createElement(_Basic.Text, {
        mb: 1,
        pt: 3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 16,
          columnNumber: 17
        }
      }, index === 0 ? (0, _i18n.default)('more_than') : (0, _i18n.default)('less_than')), _react.default.createElement(_Basic.Text, {
        size: "largest",
        bold: true,
        pb: 3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 19,
          columnNumber: 17
        }
      }, goal.label));
    }
  }]);
  return GoalCard;
}(_react.default.Component);

GoalCard.propTypes = {
  index: _propTypes.default.number,
  goal: _propTypes.default.object.isRequired
};
var _default = GoalCard;
exports.default = _default;